export class BeneficiaryConfiguration {
  private key: string;
  private companyFiscalNumber: string;
  private allowOrderCard: boolean;
  private orderCardQuantity: number;

  setKey(key: string): void {
    this.key = key;
  }

  getKey(): string {
    return this.key;
  }

  isNew(): boolean {
    return !this.key;
  }

  setCompanyFiscalNumber(fiscalNumber: string): void {
    this.companyFiscalNumber = fiscalNumber;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setAllowOrderCard(value: boolean): void {
    this.allowOrderCard = value;
  }

  getAllowOrderCard(): boolean {
    return this.allowOrderCard;
  }

  setOrderCardQuantity(value: number): void {
    this.orderCardQuantity = value;
  }

  getOrderCardQuantity(): number {
    return this.orderCardQuantity;
  }
}
